import React, { Component } from 'react'
import { connect } from 'react-redux'

import styled from "styled-components"
import cookie from '../../cookie'

import './index.scss'

const FullImage = styled.img`
    position: absolute;
    width: 0px;
    height: 0px;

    top: 0;
    right: 0;

    cursor: pointer;
    @keyframes openAnimation-${props => props.animkey} {
        0% {
            width: 0px;
            height: 0px;
        }
        100% {
            width: ${props => props.fullWidth}px;
            height: ${props => props.fullHeight}px;
            border: 1px solid #cccccc;
            border-radius: 30px;
        }
    }
    @keyframes closeAnimation-${props => props.animkey} {
        0% {
            width: ${props => props.fullWidth}px;
            height: ${props => props.fullHeight}px;
            border: 1px solid #cccccc;
            border-radius: 30px;
        }
        100% {
            width: 0px;
            height: 0px;
        }
    }
`

class EventPopup extends Component {

    mouseLeaveTimeMap = {}

    state = {
        hoverMap: {}
    }

    getContents = () => {
        if (cookie.GetCookie('isEventPopupClose24Hour')) return []

        const { lang } = this.props
        const list = []

        // [최명수] 24.07.12 비대면 바우처 사업 종료로 인한 팝업 제거
        // if (lang === 'ko') {
        //     list.push({
        //         key: 'k-voucher',
        //         smallImageSrc: "https://front.videomonster.com/images-u6yd72dy/web/eventPopup/web_popup_k_voucher_circle.png",
        //         fullImageSrc: "https://front.videomonster.com/images-u6yd72dy/web/eventPopup/full_popup_k_voucher.png",
        //         fullWidth: 350,
        //         fullHeight: 350,
        //         clickAction: {
        //             type: 'new_window',
        //             link: `https://www.k-voucher.kr/index.php/page/productSearch?mode=update&seq=913`
        //         }
        //     })
        // }

        return list
    }

    handleMouseEnter = index => {
        const mouseLeaveTime = this.mouseLeaveTimeMap[index]
        if (!mouseLeaveTime || Date.now() - mouseLeaveTime >= 200) {
            const { hoverMap } = this.state
            this.setState({
                hoverMap: {
                    ...hoverMap,
                    [index]: true
                }
            })
        }
    }

    handleMouseLeave = index => {
        this.mouseLeaveTimeMap[index] = Date.now()

        const { hoverMap } = this.state
        this.setState({
            hoverMap: {
                ...hoverMap,
                [index]: false
            }
        })
    }

    handleClickImage = data => {
        if (!data) return
        const { type, link } = data

        switch (type) {
            case 'new_window':
                window.open(link, '_blank')
                break

            case 'history_push':
                this.props.history.push(link)
                break

            default: break
        }
    }

    handleClickCloseBtn = () => {
        cookie.SetCookie('isEventPopupClose24Hour', true, 24 * 60 * 60 * 1000)
        this.forceUpdate()
    }

    render() {
        const { lang } = this.props
        const { hoverMap } = this.state
        const contents = this.getContents()

        // EVENT LOGIC START (제거예정)
        // 사이드이펙트 고려안된 임시코드
        let eventElement = null
        
        if (!cookie.GetCookie('isEventPopupClose24Hour')) {
            switch (lang) {
                // case 'vi':
                // case 'th':
                // case 'id':
                //     eventElement = (
                //         <div className="event-popup-contents" style={{ top: 0 }}>
                //             <img
                //                 src={`/images/web/eventPopup/event_pricing_down_${lang}.png`}
                //                 alt=""
                //                 style={{ width: 200, cursor: 'pointer' }}
                //                 onClick={() => this.props.history.push('/payment')}
                //             />
                //         </div>
                //     )
                //     break

                default:
                    break
            }
        }
        if ((!contents || contents.length === 0) && !eventElement) return null

        // EVENT LOGIC END
        // if (!contents || contents.length === 0) return null

        return (
            <div className="event-popup-root-container">
                <img
                    className="close-btn"
                    src="https://front.videomonster.com/images-u6yd72dy/web/eventPopup/x.svg"
                    alt=""
                    onClick={this.handleClickCloseBtn}
                />
                {eventElement}
                {
                    contents.map(({ key, smallImageSrc, fullImageSrc, fullWidth, fullHeight, clickAction }, index) => {
                        const isHover = hoverMap[index]
                        return (
                            <div className="event-popup-contents" style={{ top: index * 145, zIndex: contents.length - index }}>
                                <img
                                    className="small-image"
                                    src={smallImageSrc}
                                    alt=""
                                    onMouseEnter={() => this.handleMouseEnter(index)}
                                />
                                {
                                    (fullImageSrc && typeof isHover === 'boolean') &&
                                    <FullImage
                                        animkey={key}
                                        src={fullImageSrc}
                                        alt=""
                                        fullWidth={fullWidth}
                                        fullHeight={fullHeight}
                                        style={{
                                            animation: `${isHover ? `openAnimation-${key}` : `closeAnimation-${key}`} 0.2s ease-in forwards`
                                        }}
                                        onMouseEnter={() => this.handleMouseEnter(index)}
                                        onMouseLeave={() => this.handleMouseLeave(index)}
                                        onClick={() => this.handleClickImage(clickAction)}
                                    />
                                }
                            </div>
                        )
                    })
                }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(EventPopup)